import { bootstrapApplication } from '@angular/platform-browser'
import * as Sentry from '@sentry/angular'

import { appConfig } from './app/app.config'
import { AppComponent } from './app/app.component'
import { environment } from './app/environments/environment'

Sentry.init({
  dsn: 'https://952f81471d17ae1719244374723d086a@o474392.ingest.us.sentry.io/4508964326670336',
  environment: environment.sentry.environment,
  integrations: [],
})

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err))
